<template>
  <div id="mainBox">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <el-alert
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom: 12px"
      title="优先在官方寄售「拍卖中」商品上点「关联闲鱼商品」预绑闲鱼商品 id，成交后会自动进待发货列表发货。本页仅处理未预关联的历史/漏绑单：关联自研商品后发货，或「闲鱼已处理」移除。"
    />

    <div class="flex search-box">
      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">闲鱼单号：</span>
        <div style="width: 180px">
          <el-input
            v-model="query.goofishOrderNo"
            placeholder="模糊查询"
            clearable
            @keyup.enter.native="searchFn"
          />
        </div>
      </div>
      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">自研单号：</span>
        <div style="width: 180px">
          <el-input v-model="query.orderNo" placeholder="模糊查询" clearable @keyup.enter.native="searchFn" />
        </div>
      </div>
      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">时间：</span>
        <div style="width: 290px">
          <el-date-picker
            v-model="query.timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </div>
      </div>
    </div>

    <div class="operate-btns">
      <el-button type="success" size="medium" @click="searchFn">搜索</el-button>
      <el-button size="medium" @click="resetFn">重置</el-button>
      <el-button
        type="warning"
        size="medium"
        :loading="refreshMissingLoading"
        @click="refreshMissingReceivers"
      >刷新本页缺失地址</el-button>
    </div>

    <el-tabs v-model="activeTab" type="card" class="status-tabs" @tab-click="handleTabClick">
      <el-tab-pane v-for="t in tabs" :key="t.name" :label="t.label" :name="t.name" />
    </el-tabs>

    <div class="table-scroll-wrap">
      <el-table class="data-table" :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
        <el-table-column prop="goofishOrderNo" width="170" align="center" label="闲鱼单号" show-overflow-tooltip />
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="statusTagType(scope.row)">{{ scope.row.bindStatusLabel || "-" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="xianyuItemId" width="130" align="center" label="闲鱼商品id" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.xianyuItemId || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="店铺" width="130" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.accountName || "-" }}</div>
            <div v-if="scope.row.userName" style="color: #999; font-size: 12px">{{ scope.row.userName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="实付(元)" width="90" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.payAmount) }}</template>
        </el-table-column>
        <el-table-column label="收货人" width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.receiverName || "-" }}</template>
        </el-table-column>
        <el-table-column label="电话" width="120" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.receiverPhone || "-" }}</template>
        </el-table-column>
        <el-table-column label="地址" min-width="200" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.receiverAddress || "-" }}</template>
        </el-table-column>
        <el-table-column label="关联商品" min-width="180" align="left" class-name="cell-title-wrap">
          <template slot-scope="scope">
            <div v-if="scope.row.productId">
              <div>{{ scope.row.productNo || "-" }}</div>
              <div style="color: #666">{{ scope.row.productTitle || "" }}</div>
            </div>
            <span v-else style="color: #999">未关联</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" width="150" align="center" label="自研单号" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.orderNo || "-" }}</template>
        </el-table-column>
        <el-table-column label="闲鱼物流" width="100" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.secondhandOrderId">
              <el-tag v-if="Number(scope.row.goofishShipSynced) === 1" type="success" size="mini">已回写</el-tag>
              <el-tag v-else-if="scope.row.logisticsNo" type="warning" size="mini">待回写</el-tag>
              <span v-else style="color: #999">未发货</span>
            </template>
            <span v-else style="color: #999">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="payTime" width="160" align="center" label="支付时间">
          <template slot-scope="scope">{{ formatTime(scope.row.payTime) }}</template>
        </el-table-column>
        <el-table-column min-width="280" align="left" label="操作" fixed="right">
          <template slot-scope="scope">
            <div style="display: flex; flex-wrap: wrap; gap: 6px">
              <el-button
                v-if="scope.row.bindStatus === 'PENDING_BIND'"
                type="primary"
                size="small"
                @click="openBind(scope.row)"
              >关联商品</el-button>
              <el-button
                v-if="scope.row.bindStatus === 'PENDING_SHIP' && scope.row.secondhandOrderId"
                type="success"
                size="small"
                @click="confirmDelivery(scope.row)"
              >确认发货</el-button>
              <el-button
                v-if="canMarkExternalHandled(scope.row)"
                type="warning"
                size="small"
                plain
                :loading="markExternalLoadingId === scope.row.goofishOrderNo"
                @click="markExternalHandled(scope.row)"
              >闲鱼已处理</el-button>
              <el-button
                size="small"
                :loading="refreshReceiverLoadingId === scope.row.goofishOrderNo"
                @click="refreshReceiver(scope.row)"
              >刷新地址</el-button>
              <el-button
                v-if="canRetryGoofishShip(scope.row)"
                class="btn-goofish"
                size="small"
                :loading="goofishShipRetryLoadingId === scope.row.secondhandOrderId"
                @click="retryGoofishShip(scope.row)"
              >重新推送</el-button>
              <el-button type="info" size="small" @click="copyAddress(scope.row)">复制地址</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination" style="margin-top: 16px; text-align: right">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[10, 20, 50]"
        :total="tableTotal"
        @current-change="changePage"
        @size-change="handlePageSizeChange"
      />
    </div>

    <el-dialog title="关联拍卖中商品" :visible.sync="bindVisible" width="720px" :close-on-click-modal="false">
      <div style="margin-bottom: 12px; color: #666">
        闲鱼单号：{{ bindRow && bindRow.goofishOrderNo }}
        <span v-if="bindRow && bindRow.xianyuItemId">　闲鱼商品id：{{ bindRow.xianyuItemId }}</span>
      </div>
      <div class="flex" style="margin-bottom: 12px; gap: 8px; align-items: center">
        <el-input
          v-model="bindKeyword"
          placeholder="商品编号或标题"
          clearable
          style="width: 260px"
          @keyup.enter.native="searchAuctionProducts"
        />
        <el-button type="primary" size="small" :loading="bindSearchLoading" @click="searchAuctionProducts">搜索</el-button>
      </div>
      <el-table
        :data="auctionProducts"
        border
        max-height="360"
        v-loading="bindSearchLoading"
        highlight-current-row
        @current-change="onAuctionProductSelect"
      >
        <el-table-column width="50" align="center">
          <template slot-scope="scope">
            <el-radio v-model="selectedProductId" :label="scope.row.id">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="productNo" label="编号" width="120" align="center" />
        <el-table-column prop="title" label="标题" min-width="200" class-name="cell-title-wrap" />
        <el-table-column label="价格" width="90" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.price) }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="bindVisible = false">取消</el-button>
        <el-button type="primary" :loading="bindLoading" @click="submitBind">确认关联</el-button>
      </span>
    </el-dialog>

    <el-dialog title="确认发货" :visible.sync="shipVisible" width="560px" :close-on-click-modal="false">
      <el-form label-width="100px">
        <el-form-item label="订单号">{{ shipForm.orderNo || "-" }}</el-form-item>
        <el-form-item label="收货人">{{ shipForm.receiverName || "-" }}</el-form-item>
        <el-form-item label="电话">{{ shipForm.receiverPhone || "-" }}</el-form-item>
        <el-form-item label="地址">{{ shipForm.receiverAddress || "-" }}</el-form-item>
        <el-form-item label="物流公司" required>
          <el-select v-model="shipForm.expressCompany" filterable clearable placeholder="请选择" style="width: 100%">
            <el-option v-for="c in companyData" :key="c" :label="c" :value="c" />
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" required>
          <el-input v-model="shipForm.expressNo" clearable placeholder="请输入物流单号" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="shipVisible = false">取消</el-button>
        <el-button type="primary" :loading="shipLoading" @click="submitShip">确认发货</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import historyTag from "@/components/historyTag";
import expressInfo from "@/util/expressInfo";
import { api } from "@/util/requestUrl";
import { resolveCreateTimeRange } from "@/util/inspectionJobTimeRange";

export default {
  components: { historyTag },
  data() {
    return {
      historyArr: ["鉴别作业", "闲鱼拍卖待发货"],
      tableData: [],
      currentPage: 1,
      pageSize: 50,
      tableTotal: 0,
      loading: false,
      activeTab: "ALL",
      tabs: [
        { label: "待处理", name: "ALL" },
        { label: "待关联", name: "PENDING_BIND" },
        { label: "待发货", name: "PENDING_SHIP" },
        { label: "待收货", name: "PENDING_RECEIVE" },
      ],
      query: {
        timeRange: null,
        goofishOrderNo: "",
        orderNo: "",
      },
      bindVisible: false,
      bindLoading: false,
      bindSearchLoading: false,
      bindRow: null,
      bindKeyword: "",
      auctionProducts: [],
      selectedProductId: null,
      shipVisible: false,
      shipLoading: false,
      goofishShipRetryLoadingId: null,
      refreshReceiverLoadingId: null,
      markExternalLoadingId: null,
      refreshMissingLoading: false,
      companyData: expressInfo.arr || [],
      shipForm: {
        id: null,
        orderNo: "",
        receiverName: "",
        receiverPhone: "",
        receiverAddress: "",
        expressCompany: "",
        expressNo: "",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    buildListParams() {
      const params = {
        page: this.currentPage,
        size: this.pageSize,
        goofishOrderNo: this.query.goofishOrderNo || null,
        orderNo: this.query.orderNo || null,
      };
      if (this.activeTab && this.activeTab !== "ALL") {
        params.tab = this.activeTab;
      }
      Object.assign(params, resolveCreateTimeRange(this.query.timeRange));
      return params;
    },

    getList() {
      this.loading = true;
      this.$axios
        .post(api.goofishAuctionPendingShipList, this.buildListParams())
        .then((res) => {
          this.loading = false;
          if (res.data.code === 200) {
            const page = res.data.data || {};
            this.tableData = page.records || [];
            this.tableTotal = page.total || 0;
          } else {
            this.$message.error(res.data.msg || "获取列表失败");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("网络异常");
        });
    },

    searchFn() {
      this.currentPage = 1;
      this.getList();
    },

    resetFn() {
      this.query = { timeRange: null, goofishOrderNo: "", orderNo: "" };
      this.activeTab = "ALL";
      this.currentPage = 1;
      this.getList();
    },

    handleTabClick() {
      this.currentPage = 1;
      this.getList();
    },

    changePage(page) {
      this.currentPage = page;
      this.getList();
    },

    handlePageSizeChange() {
      this.currentPage = 1;
      this.getList();
    },

    statusTagType(row) {
      const s = row && row.bindStatus;
      if (s === "PENDING_BIND") return "danger";
      if (s === "PENDING_SHIP") return "warning";
      if (s === "PENDING_RECEIVE") return "";
      return "info";
    },

    openBind(row) {
      this.bindRow = row;
      this.bindKeyword = "";
      this.selectedProductId = null;
      this.auctionProducts = [];
      this.bindVisible = true;
      this.searchAuctionProducts();
    },

    searchAuctionProducts() {
      this.bindSearchLoading = true;
      const body = {
        page: 1,
        size: 30,
        productType: 1,
        consignStage: "IN_AUCTION",
      };
      const kw = String(this.bindKeyword || "").trim();
      if (kw) {
        // 后端 filterProductNo 与 title 是 AND；同一词两边都塞会导致按编号搜不到
        if (/^G\d+/i.test(kw) || /\d{6,}/.test(kw)) {
          body.filterProductNo = kw;
        } else {
          body.title = kw;
        }
      }
      this.$axios
        .post(api.selSecondhandProduct, body)
        .then((res) => {
          this.bindSearchLoading = false;
          if (res.data && res.data.code === 200) {
            // getList 的 data 直接是数组（非 { records } 分页对象）
            const raw = res.data.data;
            this.auctionProducts = Array.isArray(raw)
              ? raw
              : (raw && (raw.records || raw.list)) || [];
          } else {
            this.$message.error((res.data && res.data.msg) || "搜索失败");
          }
        })
        .catch(() => {
          this.bindSearchLoading = false;
          this.$message.error("网络异常");
        });
    },

    onAuctionProductSelect(row) {
      if (row && row.id) {
        this.selectedProductId = row.id;
      }
    },

    submitBind() {
      if (!this.bindRow || !this.bindRow.goofishOrderNo) {
        return;
      }
      if (!this.selectedProductId) {
        this.$message.error("请选择拍卖中商品");
        return;
      }
      this.bindLoading = true;
      this.$axios
        .post(api.goofishAuctionPendingShipBind, {
          goofishOrderNo: this.bindRow.goofishOrderNo,
          productId: this.selectedProductId,
        })
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.$message.success(res.data.msg || "关联成功");
            this.bindVisible = false;
            this.getList();
          } else {
            this.$message.error((res.data && res.data.msg) || "关联失败");
          }
        })
        .catch(() => {
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.bindLoading = false;
        });
    },

    confirmDelivery(row) {
      this.shipForm = {
        id: row.secondhandOrderId,
        orderNo: row.orderNo || "",
        receiverName: row.receiverName || "",
        receiverPhone: row.receiverPhone || "",
        receiverAddress: row.receiverAddress || "",
        expressCompany: "",
        expressNo: "",
      };
      this.shipVisible = true;
    },

    submitShip() {
      const f = this.shipForm || {};
      const company = (f.expressCompany || "").trim();
      if (!company) {
        this.$message.error("请选择物流公司");
        return;
      }
      const no = (f.expressNo || "").trim();
      if (!no) {
        this.$message.error("请填写物流单号");
        return;
      }
      this.shipLoading = true;
      this.$axios
        .post(api.updateSecondhandOrder, {
          id: f.id,
          logisticsCompany: company,
          logisticsNo: no,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("已确认发货");
            this.shipVisible = false;
            this.getList();
          } else {
            this.$message.error(res.data.msg || "操作失败");
          }
        })
        .catch(() => {
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.shipLoading = false;
        });
    },

    hasReceiverInfo(row) {
      if (!row) return false;
      return !!(row.receiverName || row.receiverPhone || row.receiverAddress);
    },

    refreshReceiver(row) {
      if (!row || !row.goofishOrderNo) return;
      this.refreshReceiverLoadingId = row.goofishOrderNo;
      this.$axios
        .post(api.goofishAuctionPendingShipRefreshReceiver, {
          goofishOrderNo: row.goofishOrderNo,
        })
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.$message.success(res.data.msg || "已刷新");
            this.getList();
          } else {
            this.$message.error((res.data && res.data.msg) || "刷新失败");
          }
        })
        .catch(() => {
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.refreshReceiverLoadingId = null;
        });
    },

    async refreshMissingReceivers() {
      const rows = (this.tableData || []).filter((r) => r && r.goofishOrderNo && !this.hasReceiverInfo(r));
      if (!rows.length) {
        this.$message.info("本页没有缺失收货地址的订单");
        return;
      }
      this.refreshMissingLoading = true;
      let ok = 0;
      let empty = 0;
      let fail = 0;
      try {
        for (const row of rows) {
          try {
            const res = await this.$axios.post(api.goofishAuctionPendingShipRefreshReceiver, {
              goofishOrderNo: row.goofishOrderNo,
            });
            if (res.data && res.data.code === 200) {
              if (res.data.data === true) ok += 1;
              else empty += 1;
            } else {
              fail += 1;
            }
          } catch (e) {
            fail += 1;
          }
        }
        this.$message.success(`刷新完成：有地址 ${ok}，仍无地址 ${empty}，失败 ${fail}`);
        this.getList();
      } finally {
        this.refreshMissingLoading = false;
      }
    },

    canRetryGoofishShip(row) {
      if (!row || !row.secondhandOrderId || !row.logisticsNo) return false;
      return true;
    },

    canMarkExternalHandled(row) {
      if (!row || !row.goofishOrderNo) return false;
      const s = row.bindStatus;
      return s === "PENDING_BIND" || s === "PENDING_SHIP" || s === "PENDING_RECEIVE";
    },

    markExternalHandled(row) {
      if (!row || !row.goofishOrderNo) return;
      this.$confirm(
        `确认闲鱼单 ${row.goofishOrderNo} 已在闲鱼侧发货并完成交易？确认后将从待处理列表移除；未关联商品时不会创建自研履约单。`,
        "标记闲鱼已处理",
        { type: "warning", confirmButtonText: "确认移除", cancelButtonText: "取消" }
      )
        .then(() => {
          this.markExternalLoadingId = row.goofishOrderNo;
          return this.$axios.post(api.goofishAuctionPendingShipMarkExternalHandled, {
            goofishOrderNo: row.goofishOrderNo,
          });
        })
        .then((res) => {
          if (!res) return;
          if (res.data && res.data.code === 200) {
            this.$message.success(res.data.msg || "已标记完成");
            this.getList();
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .catch((err) => {
          if (err === "cancel" || err === "close") return;
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.markExternalLoadingId = null;
        });
    },

    retryGoofishShip(row) {
      this.goofishShipRetryLoadingId = row.secondhandOrderId;
      this.$axios
        .post(api.goofishRetryShipSync, { secondhandOrderId: row.secondhandOrderId })
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.$message.success(res.data.msg || "回写成功");
            this.getList();
          } else {
            this.$message.error((res.data && res.data.msg) || "回写失败");
          }
        })
        .catch(() => {
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.goofishShipRetryLoadingId = null;
        });
    },

    copyAddress(row) {
      const text = `${row.receiverName || ""} ${row.receiverPhone || ""} ${row.receiverAddress || ""}（${
        row.goofishOrderNo || row.orderNo || "-"
      }）`.trim();
      if (!text || text === "（-）") {
        this.$message.warning("无地址可复制");
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(
          () => this.$message.success("已复制"),
          () => this.fallbackCopy(text)
        );
      } else {
        this.fallbackCopy(text);
      }
    },

    fallbackCopy(text) {
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        this.$message.success("已复制");
      } catch (e) {
        this.$message.error("复制失败");
      }
      document.body.removeChild(ta);
    },

    formatMoney(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return Number.isFinite(n) ? n.toFixed(2) : String(v);
    },

    formatTime(v) {
      if (!v) return "-";
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return String(v);
      const p = (n) => (n < 10 ? "0" + n : "" + n);
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(
        d.getSeconds()
      )}`;
    },
  },
};
</script>

<style scoped>
.search-box {
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.search-item {
  display: flex;
  align-items: center;
}
.operate-btns {
  margin-bottom: 12px;
}
.btn-goofish {
  color: #e6a23c;
  border-color: #f3d19e;
  background: #fdf6ec;
}
</style>



// WEBPACK FOOTER //
// src/pages/goofish/auctionPendingShip/index.vue